import React, { useState } from 'react';
import moment from 'moment';
import { ReferenceManyField, SingleFieldList, useTranslate } from 'react-admin';
import Button from '@material-ui/core/Button';
import ScheduleChipField from './ScheduleChipField';

const ScheduleChipWrapper = ({ autoLoad = false, ...props }) => {
  const [clicked, setClicked] = useState(autoLoad);
  const { basePath, record } = props;
  const { client_location_id, default_client_location_id } = record;
  const location =
    basePath === '/customer' ? default_client_location_id : client_location_id;
  const translate = useTranslate();
  const filters = {
    start_time_after: moment().format('YYYY-MM-DD'),
    sorted: true,
    client_location_id: location,
  };

  const handleClick = (event) => {
    event.stopPropagation();
    setClicked(true);
  };

  return (
    <div>
      {clicked ? (
        <ReferenceManyField
          filter={filters}
          target="record.client_location_id"
          source="record.client_location_id"
          reference="schedule"
          perPage={20}
          {...props}
        >
          <SingleFieldList linkType={false}>
            <ScheduleChipField />
          </SingleFieldList>
        </ReferenceManyField>
      ) : (
        <Button onClick={handleClick}>
          {translate(
            'resources.scheduled-work.actions.load_upcoming_schedule_dates',
          )}
        </Button>
      )}
    </div>
  );
};

export default ScheduleChipWrapper;
